function AvailableHeader() {
  return (
    <div className="available__header-text">
      <h2 className="available__header">Your results</h2>
      <p className="available__text">
        Your results are shown below based on the information you provided. To
        adjust the results, edit the form and click "calculate repayments"
        again.
      </p>
    </div>
  );
}

export default AvailableHeader;
